import { api } from "./client";

// sys-only maintenance API (/api/v1/sys/maintenance/*). The backend re-checks
// role=sys; this client is only the UI surface.

export type MaintenanceKind = "table" | "logs" | "readonly";

export interface MaintenancePolicy {
  key: string;
  label: string;
  kind: MaintenanceKind;
  tables?: { table: string; time_column: string }[];
  default_days: number;
  presets: number[];
  note: string;
  disabled: boolean;
  disabled_reason?: string;
}

export interface PreviewTable {
  table: string;
  rows: number;
}

export interface MaintenancePreview {
  target: string;
  before: string;
  rows: number;
  tables?: PreviewTable[];
  files?: number;
  archive_dir: string;
  warnings?: string[];
}

export interface MaintenanceExecuteResult {
  target: string;
  before: string;
  rows: number;
  files?: number;
  tables?: { table: string; rows: number; file?: string; sha256?: string }[];
  archive_dir: string;
  manifest: string;
}

export interface MaintenanceAudit {
  id: number;
  action: string;
  target_key: string;
  before_state: string;
  after_state: string;
  note: string;
  operator_name: string;
  occurred_at: string;
}

const EXECUTE_TIMEOUT_MS = 300_000;

export const maintenanceApi = {
  policies: () => api.get<{ items: MaintenancePolicy[] }>("/sys/maintenance/policies"),

  preview: (target: string, before: string) =>
    api.post<MaintenancePreview>("/sys/maintenance/preview", { target, before }),

  execute: (target: string, before: string, confirmText: string) =>
    api.post<MaintenanceExecuteResult>(
      "/sys/maintenance/execute",
      { target, before, confirm_text: confirmText },
      EXECUTE_TIMEOUT_MS
    ),

  history: () =>
    api.get<{ items: MaintenanceAudit[]; total: number }>("/audit-logs?action=SYS_CLEANUP"),
};
